import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "booking-meeting-room-front";


export type booking_classroom_payment_data = {
    id_meeting_room: number;
    meeting_room_payment_date: string;
    meeting_room_payment_time?: string;
    currency: string,
    meeting_room_payment_amount: number | string;
    id_files_payment: number[]
}


export type cancel_booking_type_data = {
    id_meeting_room: number;
    meeting_room_approve_date: string;
    after_approves_day: number;
    meeting_room_start_date: string;
    before_booking_day: number;
}

export class BookingMeetingRoomFront extends BaseAPI {
    static uploadMultiFile(files: FormData): Promise<AxiosResponse> {
        return this.api.post(`${path}/upload-files`, files, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    static downloadFile(id_meeting_room_file: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/file/${id_meeting_room_file}`, {
            responseType: "arraybuffer"
        })
    }

    static findOnePayment(id_meeting_room: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/get-one/${id_meeting_room}/payment`)
    }
    static sendPayment(body: booking_classroom_payment_data): Promise<AxiosResponse> {
        return this.api.post(`${path}/payment`, body)
    }
    static cancelBooking(body: cancel_booking_type_data): Promise<AxiosResponse> {
        return this.api.post(`${path}/cancel-booking`, body)
    }
    static updatePayment(id_meeting_room_payment: number, body: booking_classroom_payment_data): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_meeting_room_payment}/payment`, body)
    }
}